import { httpClient } from './client';

import type { Customer, NewCustomer } from '../types/customer';

/**
 * Fetch customer autocomplete suggestions for a free-text search string.
 *
 * Pass an `AbortSignal` to make the request cancelable — callers that re-request
 * on each keystroke should abort the prior in-flight request and pass a fresh
 * signal so a stale response can't clobber a newer one.
 */
export const getCustomerAutocomplete = async (searchString: string, signal?: AbortSignal): Promise<Customer[]> => {
  const response = await httpClient.get(`/customer/autocomplete/${encodeURIComponent(searchString)}`, { signal });
  return response?.data ?? [];
};

export const createCustomer = async (customer: NewCustomer): Promise<void> => {
  await httpClient.post('/customer', customer);
};
